import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceShareApiService } from './residence-share-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceShareApiService extends GeneratedResidenceShareApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
